import styled, { keyframes } from 'styled-components';
import Image from 'next/image';

// Animations
const fadeInDown = keyframes`
   from {
      opacity: 0;
      transform: translateY(-16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
`;

const fadeInUp = keyframes`
   from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
`;

export const CloseButton = styled.button`
  position: fixed;
  top: 24px;
  right: 24px;
  height: 48px;
  width: 48px;
  margin-bottom: 10px;
  cursor: pointer;
  transform: scale(1);
  transition: all 0.3s ease;
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  z-index: 1000001;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    width: 32px;
    height: 32px;
  }
`;

export const IconClose = styled(Image)`
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    width: 16px;
    height: 16px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 24px;
  opacity: 0;
  animation: ${fadeInDown} 400ms ease-out forwards;
  animation-delay: 2s;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    position: absolute;
    bottom: 32px;
    animation: ${fadeInUp} 400ms ease-out forwards;
    animation-delay: 2s;
  }
`;

export const VideoWrapper = styled.div`
  video {
    max-height: 80vh;
    max-width: 80vw;
  }
`;
